import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CancelJobMatchMeetingComponent } from './cancel-job-match-meeting.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { ExternalNotesModule } from '../../external-notes/external-notes.module';
import { AiAssistantModule } from '../../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [CancelJobMatchMeetingComponent],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule.forRoot(),
    ExternalNotesModule,
    AiAssistantModule
  ],
  exports: [CancelJobMatchMeetingComponent],
  entryComponents: [CancelJobMatchMeetingComponent]
})
export class CancelJobMatchMeetingModule { }
